import script from "./salesreturnlist.vue?vue&type=script&setup=true&lang=js"
export * from "./salesreturnlist.vue?vue&type=script&setup=true&lang=js"

import "./salesreturnlist.vue?vue&type=style&index=0&id=e8fc45b6&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8fc45b6"]])

export default __exports__